import cx from 'classnames';
import { Text } from 'components/@tedui';
import { Link } from 'components/router';
import { useDarkMode } from 'components/theme/DarkModeProvider';
import React from 'react';

export type BreadcrumbsProps = {
  links: { label: string; link?: string }[];
};

function Breadcrumbs({
  links,
  ...props
}: BreadcrumbsProps & React.HTMLAttributes<HTMLElement>): React.ReactNode {
  const { isDarkMode } = useDarkMode();

  return (
    <nav {...props}>
      <Text
        variant="body2"
        color={{ isOnLightSurface: !isDarkMode }}
        weight="font-normal"
      >
        <>
          {links.map((link, index) => {
            const breadcrumb = link.link ? (
              <Link
                className={cx('mr-3 inline-block', {
                  'hover:text-black/50': !isDarkMode,
                  'text-white/50 hover:text-white': isDarkMode
                })}
                href={link.link}
              >
                {link.label}
              </Link>
            ) : (
              <span className="mr-3 inline-block">{link.label}</span>
            );
            return (
              <React.Fragment key={link.label}>
                {breadcrumb}
                {index < links.length - 1 && (
                  <span className="mr-3" aria-hidden>
                    ›
                  </span>
                )}
              </React.Fragment>
            );
          })}
        </>
      </Text>
    </nav>
  );
}

export default Breadcrumbs;
